import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ChatComponent } from './chat.component';
import { ChatPreviewComponent } from './chat-preview/chat-preview.component';
import { ChatSendMessageComponent } from './chat-send-message/chat-send-message.component';
import { ReactiveFormsModule } from '@angular/forms';
import { DesignSystemModule } from '@bcl/design-system';
import { FileStoreModule } from '@bcl/file-store';
import { TranslateModule } from '@ngx-translate/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { TextFieldModule } from '@angular/cdk/text-field';
import { PipesModule } from 'src/app/pipes/pipes.module';
import { ChatMessageComponent } from './chat-message/chat-message.component';
import { NotesListModule } from '../notes-list/notes-list.module';
import { IonicModule } from '@ionic/angular';

@NgModule({
  declarations: [
    ChatComponent,
    ChatPreviewComponent,
    ChatSendMessageComponent,
    ChatMessageComponent,
  ],
  imports: [
    CommonModule,
    DesignSystemModule,
    FileStoreModule,
    IonicModule,
    MatTooltipModule,
    MatProgressSpinnerModule,
    NotesListModule,
    PipesModule,
    ReactiveFormsModule,
    TextFieldModule,
    TranslateModule,
  ],
  exports: [ChatComponent],
})
export class ChatModule {}
